import * as React from "react"

import {AppAntSwitch} from "@components";


export default function PriceSwitch({ value, onChange, isPercentage }) {
	return <AppAntSwitch
		trueText={isPercentage ? "Discount vs RRSP Price" : "Actual Price"}
		falseText={isPercentage ? "Discount vs List Price" : "List Price"}
		checked={value}
		onChange={e => onChange(e.target.checked)}
	/>
}